@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.feedbackModal {
  .modalBody {
    padding: @space-24;
    min-height: 60px;
  }

  .modalFooter {
    padding: @space-20 @space-24;
    gap: @space-12;
  }

  .feedbackTextArea {
    margin-top: @space-16;
    min-height: 100px;
    resize: vertical;
  }
}
